export const MFE_QUERY_PARAM_PREFIX = 'mfe-';
export const MFE_PR_PARAM_SUFFIX = '-pr';
export const MFE_EXPIRY_PARAM_SUFFIX = '-expiry';

/**
 * The expiry value to use when you want a query-param-loaded MFE to persist
 * indefinitely (no expiry). Usage: ?mfe-marketing=42&mfe-marketing-expiry=never
 * The entry will remain in localStorage until manually cleared via the toolbar.
 */
export const NEVER_EXPIRY_VALUE = 'never';

/**
 * Query-param-loaded overrides expire at 23:59:59 on the day they are first opened.
 *
 * Rationale: most users are Ireland/UK-based and rarely work past midnight, so
 * "end of today" gives a full working day without leaving stale overrides active
 * the following morning. Use ?mfe-{name}-expiry=never for a persistent override,
 * or supply an explicit ISO date via ?mfe-{name}-expiry= for a custom window.
 */
export const DEFAULT_QUERY_PARAM_EXPIRY_DAYS = 0;

/**
 * Maximum length of a PR number in a query parameter.
 *
 * Intentionally small: 10 digits is orders of magnitude more than any realistic
 * PR number and is far too short to carry an injection payload (XSS, SQL, CSS, etc.).
 * Do NOT increase this to accommodate full URLs — see the security note in
 * mfeQueryParams.ts for why only PR numbers are accepted.
 */
export const PR_NUMBER_MAX_LENGTH = 10;

/**
 * Maximum length of an expiry value in a query parameter.
 *
 * ISO 8601 datetime strings are at most 24 characters (e.g. "2026-05-06T23:59:59.999Z").
 * Values longer than this are rejected as potentially malformed or malicious.
 */
export const EXPIRY_DATE_MAX_LENGTH = 24;

export const EPHEMERAL_CDN_BASE = 'https://clients-ephemeral.portal-mfs.flipdishdev.com';

/** Builds the CDN URL for a PR preview. Used by both the toolbar UI and query-param loading. */
export const buildEphemeralPrUrl = (windowName: string, prNumber: string): string =>
  `${EPHEMERAL_CDN_BASE}/${windowName}/PR-${prNumber}/assets/index.js`;

// wider substring match is intentional — false positives OK, false negatives dangerous
export const isMaybeProd = (): boolean =>
  Boolean(window.location?.host?.includes('portal.flipdish.com')); // lgtm[js/incomplete-url-substring-sanitization]
